<template>
  <div class="container">
    <div class="container_title">
      <b>字典列表</b>
      <el-button type="primary" size="medium" icon="el-icon-plus" @click="showAddSysDataDict">新增</el-button>
    </div>
    <div class="container_search">
      <el-form :inline="true" :model="searchInfo" class="demo-form-inline">
        <el-form-item label="数据字典名称">
          <el-input v-model="searchInfo.name" placeholder="请输入" @keyup.enter.native="searchAllList"></el-input>
        </el-form-item>
        <el-form-item label="数据字典code">
          <el-input v-model="searchInfo.code" placeholder="请输入" @keyup.enter.native="searchAllList"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="success" icon="el-icon-search" @click="searchAllList">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="container_table">
       <el-table
        ref="loadTable"
        :data="tableData.records"
        border
        stripe
        style="width: 100%"
        row-key="id"
        lazy
        :load="loadChildTableData"
        :tree-props="{hasChildren: 'hasChildren'}">
        <el-table-column
          prop="name"
          label="数据字典名称"
          width="180">
        </el-table-column>
        <el-table-column
          prop="code"
          label="数据字典code"
          width="180">
        </el-table-column>
        <el-table-column
          prop="dictDesc"
          label="数据字典描述">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.row)">编辑</el-button>
        <el-popconfirm title="确定删除吗？" @confirm="handleDelete(scope.row)">
          <template #reference>
            <el-button
              size="mini"
              type="danger"
              >删除</el-button
            >
          </template>
        </el-popconfirm>
            <el-dropdown style="margin-left:10px" @command="getChildrenInfo">
              <el-button size="mini" type="primary">
                子级信息管理<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="scope.row.isNode === 1" :command="beforeHandleCommand(scope.row,'查看值信息')">查看值信息</el-dropdown-item>
                <el-dropdown-item v-if="scope.row.isNode === 1" :command="beforeHandleCommand(scope.row,'新增值信息')">新增值信息</el-dropdown-item>

                <el-dropdown-item v-else :command="beforeHandleCommand(scope.row,'新增目录信息')">新增目录信息</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="searchInfo.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableData.total">
        </el-pagination>
      </div>

      <el-dialog :title="dataDictFormTitle" :visible.sync="addDataDictDialog" :before-close="clearDataDictForm">
        <el-form :model="dataDictForm" :rules="dataDictRules" ref="ruleForm">
          <el-form-item label="数据字典名称" :label-width="staffLabelWidth" prop="name">
            <el-input v-model="dataDictForm.name" autocomplete="off"></el-input>
          </el-form-item>
          
          <el-form-item v-if="dataDictFormTitle === '添加目录信息'" label="数据字典目录级别" :label-width="staffLabelWidth" prop="isNode">
            <el-select v-model="dataDictForm.isNode" placeholder="请选择数据字典目录级别">
              <el-option label="叶子节点" value="1"></el-option>
              <el-option label="分支节点" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="disabledIsNode" label="数据字典code" :label-width="staffLabelWidth" prop="code">
            <el-input v-model="dataDictForm.code" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="数据字典描述" :label-width="staffLabelWidth" prop="dictDesc">
            <el-input v-model="dataDictForm.dictDesc" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clearDataDictForm">取 消</el-button>
          <el-button type="primary" @click="addSysDataDict('ruleForm')">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="childDictFormTitle" :visible.sync="addChildDictDialog" :before-close="clearChildDictForm">
        <el-form :model="childDictForm" :rules="dataDictRules" ref="childRuleForm">
          <el-form-item label="数据字典名称" :label-width="staffLabelWidth" prop="name">
            <el-input v-model="childDictForm.name" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="数据字典排序" :label-width="staffLabelWidth" prop="sort">
            <el-input v-model="childDictForm.sort" autocomplete="off"></el-input>
          </el-form-item>
          
          <el-form-item label="数据字典值" :label-width="staffLabelWidth" prop="value">
            <el-input v-model="childDictForm.value" autocomplete="off"></el-input>
          </el-form-item>
          
          <el-form-item label="数据字典描述" :label-width="staffLabelWidth" prop="dictDesc">
            <el-input v-model="childDictForm.dictDesc" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="clearChildDictForm">取 消</el-button>
          <el-button type="primary" @click="addSysChildDict('childRuleForm')">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="子级信息详情" :visible.sync="dictInfoDialog" width="80%" :before-close="clearDictFromInfo">
        <el-table
          v-loading="loading"
          :data="dictTableData"
          style="width: 100%">
          <el-table-column
            label="数据字典名称"
            prop="name">
          </el-table-column>
          <el-table-column
            label="数据字典值"
            prop="value">
          </el-table-column>
          <el-table-column
            label="数据字典排序"
            prop="sort">
          </el-table-column>
          <el-table-column
            label="创建时间"
            prop="createTime">
          </el-table-column>
          <el-table-column
            label="数据字典描述"
            prop="dictDesc">
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="childHandleEdit(scope.row)">编辑</el-button>
              <el-popconfirm title="确定删除吗？" @confirm="handleDelete(scope.row)">
                <template #reference>
                  <el-button
                    size="mini"
                    type="danger"
                    >删除</el-button
                  >
                </template>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import { httpAction } from '@/api/manage'
  export default {
    data() {
      return {
        url: {
          querySysDataDict: '/wlSysDataDict/queryWlSysDataDict',
          saveSysDataDict: '/wlSysDataDict/saveWlSysDataDict',
          deleteSysDataDict: '/wlSysDataDict/deleteWlSysDataDict',
          updateSysDataDict: '/wlSysDataDict/updateWlSysDataDict'
        },
        tableData: [],
        maps: new Map(),
        disabledIsNode: false,
        searchInfo: {
          name: '',
          code: '',
          pageNo: 1,
          pageSize: 10
        },
        addDataDictDialog: false,
        staffLabelWidth: '150PX',
        addBlock: false,
        dataDictFormTitle: '',
        dataDictForm: {
          name: '',
          code: '',
          dictType: null,
          dictDesc: '',
          isNode: null,
          pid: null
        },
        dataDictRules: {
          name: [
            { required: true, message: '请填写数据字典名称', trigger: 'blur' },
          ],
          code: [
            { required: true, message: '请填写数据字典code', trigger: 'blur' }
          ],
          sort: [
            { required: true, message: '请填写数据字典排序', trigger: 'blur' }
          ],
          value: [
            { required: true, message: '请填写数据字典值', trigger: 'blur' }
          ],
          isNode: [
            { required: true, message: '请填写数据字典目录级别', trigger: 'blur' }
          ],
        },
        updateId: null,
        dictInfoDialog: false,
        dictTableData: [],
        loading: false,
        childDictFormTitle: '',
        addChildDictDialog: false,
        childDictForm: {
          name: '',
          dictType: 2,
          dictDesc: '',
          sort: null,
          value: '',
          pid: null,
          id: null
        },
        lineParentScope: {}
      }
    },
    created() {
      this.searchAllList()
    },
    watch: {
      'dataDictForm.isNode': {
        handler (newVal, oldVal) {
          if (newVal === '1') {
            this.disabledIsNode = true
          } else {
            this.disabledIsNode = false
            this.dataDictForm.code = null
          }
        }
      }
    },
    methods: {
      searchAllList () {
        httpAction(this.url.querySysDataDict, {dictType: 1, ...this.searchInfo}, 'post').then( res => {
          this.tableData = res.data
        })
      },
      loadChildTableData (tree, treeNode, resolve) {
        httpAction(this.url.querySysDataDict, {dictType: tree.dictType, pid: tree.id}, 'post').then( res => {
          if (res.code === 200) {
            resolve(res.data.records)
            this.maps.set(tree.id, { tree, treeNode, resolve });
          } else {
            this.$message.error('查看失败,请重试');
          }
        })
      },
      refreshLoadTree(pId) {
        if (!this.maps.get(pId)) return
        const { tree, treeNode, resolve } = this.maps.get(pId);
        this.$set(
          this.$refs.loadTable.store.states.lazyTreeNodeMap, 
          pId,
          []
        );
        if (tree) {
          this.loadChildTableData(tree, treeNode, resolve); 
        }
      },
      showAddSysDataDict (scope) {
        this.dataDictFormTitle = '添加目录信息'
        this.addDataDictDialog = true
        this.addBlock = true
        this.dataDictForm.dictType = 1
        if (scope.id && scope.dictType) {
          this.dataDictForm.pid = scope.id
          this.dataDictForm.dictType = scope.dictType
        }
      },
      addSysDataDict (ruleForm) {
        this.$refs[ruleForm].validate(async (valid) => {
          if (valid) {
            if (this.dataDictFormTitle === '添加目录信息') {
              httpAction(this.url.saveSysDataDict, this.dataDictForm, 'post').then( res => {
                if (res.code === 200) {
                  if (this.maps.size > 0 && this.dataDictForm.dictType === 1) {
                    this.refreshLoadTree(this.dataDictForm.pid);
                  }
                  this.$message.success('请求成功')
                  this.clearDataDictForm()
                  this.searchAllList()
                } else if (res.code === 404) {
                  this.$message.warning(res.msg)
                } else {
                  this.$message.error(res.msg);
                }
              })
            } else {
              httpAction(this.url.updateSysDataDict, {id: this.updateId, ...this.dataDictForm}, 'post').then( res => {
                if (res.code === 200) {
                  this.$message.success('修改成功')
                  this.clearDataDictForm()
                  this.searchAllList()
                  if (this.uploadPid !== 0) {
                    this.refreshLoadTree(this.uploadPid);
                  }
                }
              })
            }
          } else {
            this.$message.error('缺少必填项');
            return false;
          }
        });
      },
      clearDataDictForm () {
        this.addDataDictDialog = false
        this.addBlock = false
        this.dataDictForm = {
          name: '',
          code: '',
          dictType: null,
          dictDesc: '',
          isNode: null,
          pid: null
        }
        this.$refs['ruleForm'].clearValidate()
      },
      handleDelete (row) {
        httpAction(this.url.deleteSysDataDict, {id: row.id}, 'post').then( res => {
          if (res.code === 200 && res.data === true) {
            this.$message.success('删除成功')
            if (this.maps.size > 0 && row.dictType === 1 && row.pid !== 0) {
              this.refreshLoadTree(row.pid);
            }
            this.clearDictFromInfo()
          } else {
            this.$message.error('删除失败,请重试')
          }
        })
      },
      handleEdit (row) {
        this.dataDictFormTitle = '修改数据字典'
        this.addDataDictDialog = true
        this.updateId = row.id
        this.dataDictForm = {
          name: row.name,
          code: row.code,
          dictType: row.dictType,
          dictDesc: row.dictDesc
        }
        this.uploadPid = row.pid
      },
      handleSizeChange(val) {
        this.searchInfo.pageSize = val
        this.searchAllList()
      },
      handleCurrentChange(val) {
        this.searchInfo.pageNo = val
        this.searchAllList()
      },
      getChildrenInfo (command) {
        switch (command.command) {
        case '查看值信息':
          this.lookChildrenInfo(command.scope)
          this.lineParentScope = command.scope
          break;
        case '新增值信息':
          this.addChildrenInfo(command.scope)
          break;
        case '新增目录信息':
          this.showAddSysDataDict(command.scope)
          break; 
      }
      },
      beforeHandleCommand(scope,command){
        return {
          'scope':scope,
          'command':command
        }
      },
      lookChildrenInfo (scope) {
        this.loading = true
        this.dictInfoDialog = true
        httpAction(this.url.querySysDataDict, {dictType: 2, pid: scope.id}, 'post').then( res => {
          if (res.code === 200) {
            this.dictTableData = res.data.records
            this.loading = false
          } else {
            this.$message.error('查看失败,请重试');
          }
        })
      },
      clearDictFromInfo () {
        this.dictInfoDialog = false
        this.dictTableData = []
        this.lineParentScope = {}
      },
      addChildrenInfo (scope) {
        this.childDictForm.dictType = 2
        this.childDictFormTitle = '添加值信息'
        this.addChildDictDialog = true
        this.childDictForm.pid = scope.id
      },
      addSysChildDict (childRuleForm) {
        this.$refs[childRuleForm].validate(async (valid) => {
          if (valid) {
            if (this.childDictFormTitle === '添加值信息') {
              httpAction(this.url.saveSysDataDict, this.childDictForm, 'post').then( res => {
              if (res.code === 200) {
                  this.$message.success('添加成功')
                  this.clearChildDictForm()
                  this.searchAllList()
                } else {
                  this.$message.error('添加失败');
                }
            })
            } else {
              let {name, dictDesc, sort, value, id} = this.childDictForm
              httpAction(this.url.updateSysDataDict, {name, dictDesc, sort, value, id}, 'post').then( res => {
              if (res.code === 200) {
                  this.$message.success('修改成功')
                  this.lookChildrenInfo(this.lineParentScope)
                  this.clearChildDictForm()
                  this.searchAllList()
                } else {
                  this.$message.error('修改失败');
                }
            })
            }
          }
        });
      },
      clearChildDictForm () {
        this.$refs['childRuleForm'].clearValidate()
        this.childDictFormTitle = ''
        this.addChildDictDialog = false
        this.childDictForm = {
          name: '',
          dictType: 2,
          dictDesc: '',
          sort: null,
          value: '',
          pid: null,
          id: null
        }
      },
      childHandleEdit (row) {
        this.childDictFormTitle = '编辑值信息'
        this.addChildDictDialog = true
        this.childDictForm = {
          name: row.name,
          sort: row.sort,
          value: row.value,
          dictDesc: row.dictDesc,
          id: row.id
        }
      }
    }

  }
</script>

<style scoped lang="less">

  /deep/.el-table__cell {
    text-align: center;
  }
  /deep/.el-pagination {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .container {
    
    .container_title {
      height: 80px;
      padding: 20px;
      border-bottom: 1px solid gray;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  
    .container_search {
      padding: 20px;
      display: flex;
  
      .input {
        width: 200px;
        margin-right: 5px;
      }
    }

    .container_table {
      height: calc(100%-160px);
      overflow-y: auto;
    }
  }
</style>